module.exports = __webpack_public_path__ + "img/need2.ab0d5f14.png";